import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow",
  "use": "icon-down-arrow-usage",
  "viewBox": "0 0 2223 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 2223 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-down-arrow\"><defs><style type=\"text/css\"></style></defs><path d=\"M1461.19221244 290.66542558L1119.44447095 650.38760411 779.56420353 290.66542558h-140.06054983L1061.5527768 732.71208322h117.65086194l420.18164947-442.04665764h-138.19307576z\" fill=\"#828181\" p-id=\"4327\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol